<template>
    <div class="container my-4">
        <div v-if="title" class="row justify-content-center">
            <div class="col-5 col-sm-4 col-md-2 py-3 text-center">
                <p class="fw-600 m-2">
                    {{ title }}
                    <span class="d-inline d-md-none"
                        >&nbsp;({{ selectedItems.length }})</span
                    >
                </p>
                <hr class="linea-titulos" />
            </div>
        </div>
        <div class="row py-3">
            <div class="col-6 col-md-4">
                <div class="checkbox">
                    <input type="checkbox" class="check btn-check" />
                    <label
                        class="btn btn-seleccionar-todo"
                        @click="toggleSelectAll"
                    >
                        {{ allSelected ? "Deseleccionar" : "Seleccionar" }} todo
                    </label>
                </div>
            </div>
            <div class="col-md-4 d-none d-md-block text-center fw-600">
                <span class="fileCount">{{ selectedItems.length }}</span> ítems
                seleccionados.
            </div>
            <div class="col-6 col-md-4 text-end">
                <button
                    v-if="showSdButton"
                    class="btn btn-seleccionar-descarga"
                    :class="{ disabled: !selectedItems.length }"
                    data-bs-toggle="button"
                    @click="downloadSelectedItems('sd')"
                >
                    <span class="d-none d-xl-inline-block">Descargar</span>
                    SD<img
                        src="/img/icono-flecha-download-negra.svg"
                        width="20"
                    />
                </button>
                <button
                    class="btn btn-seleccionar-descarga"
                    :class="{ disabled: !selectedItems.length }"
                    data-bs-toggle="button"
                    @click="downloadSelectedItems"
                >
                    <span class="d-none d-xl-inline-block">Descargar</span>
                    HD<img
                        src="/img/icono-flecha-download-negra.svg"
                        width="20"
                    />
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div v-if="collection.length <= 0">
                    <p class="h2 py-3">No hay ítems para mostrar.</p>
                </div>
            </div>
        </div>
        <main v-if="collection.length > 0" class="galeria-multimedia-renault">
                <MediaItem
                    v-for="item in collection"
                    :key="item.uuid"
                    :label="item.name"
                    :inputValue="item.uuid"
                    :item="item"
                    v-model="selectedItems"
                />
        </main>
        <div class="row">
            <div class="col text-center">
                <button
                    type="button"
                    class="btn btn-seleccionar-todo mb-5 mt-3"
                    v-if="showLoadMore"
                    @click="$emit('load-more')"
                >
                    Cargar más ítems
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import MediaItem from "./MediaItem.vue";
export default {
    data() {
        return {
            selectedItems: [],
        };
    },
    components: { MediaItem },
    props: {
        title: String,
        collection: Array,
        showLoadMore: Boolean,
        showSdButton: {
            type: Boolean,
            default: true
        },
    },
    emits: ["load-more"],
    mounted() {

    },
    methods: {
        downloadSelectedItems: function (conversion) {
            this.$emit("downloaded", {uuids: this.selectedItems, conversion: conversion});
        },
        toggleSelectAll: function () {
            this.allSelected = !this.allSelected;
        },
    },
    computed: {
        allSelected: {
            get: function () {
                return this.collection.length === this.selectedItems.length;
            },
            set: function (value) {
                if (value) {
                    var selected = [];
                    this.collection.forEach((item) => {
                        selected.push(item.uuid.toString());
                    });
                    this.selectedItems = selected;
                } else {
                    this.selectedItems = [];
                }
            },
        },
    },
};
</script>
